
import React from 'react';
import { X, Shield, BarChart3, Target, Brain } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { ConsentOption } from './ConsentOption';
import { ConsentState } from './types';

interface CustomizeViewProps {
  consent: ConsentState;
  updateConsent: (type: keyof ConsentState, value: boolean) => void;
  onBack: () => void;
  onSave: () => void;
  isMobile: boolean;
}

export const CustomizeView: React.FC<CustomizeViewProps> = ({
  consent,
  updateConsent,
  onBack,
  onSave,
  isMobile
}) => {
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h3 id="cookie-customize-title" className="font-semibold text-gray-900">Customise Preferences</h3>
        <Button 
          type="button"
          variant="ghost" 
          size="sm"
          onClick={onBack}
          className="min-h-[44px] min-w-[44px]"
          aria-label="Back to cookie choices"
          title="Back to cookie choices"
        >
          <X className="w-4 h-4" aria-hidden="true" />
        </Button>
      </div>

      <ConsentOption
        icon={Shield}
        iconColor="text-green-600"
        title="Essential"
        description="Required for site functionality"
        checked={true}
        disabled={true}
      />

      <ConsentOption
        icon={BarChart3}
        iconColor="text-blue-600"
        title="Analytics"
        description="Help us improve our services"
        checked={consent.analytics}
        onChange={(checked) => updateConsent('analytics', checked)}
      />

      <ConsentOption
        icon={Target}
        iconColor="text-orange-600"
        title="Marketing"
        description="Personalised ads and content"
        checked={consent.marketing}
        onChange={(checked) => updateConsent('marketing', checked)}
      />

      <ConsentOption
        icon={Brain}
        iconColor="text-purple-600"
        title="AI Data Processing"
        description="Voice/chat interactions for AI improvement"
        checked={consent.aiData}
        onChange={(checked) => updateConsent('aiData', checked)}
        isSpecial={true}
      />

      <div className="bg-blue-50 p-3 rounded-lg border border-blue-200">
        <p className="text-xs text-blue-800">
          <strong>AI Data Notice:</strong> Voice/chat interactions are analysed by AI to improve responses. 
          Data is anonymised and stored for 30 days.
        </p>
      </div>

      <Button 
        type="button"
        onClick={onSave}
        className={`w-full bg-gradient-to-r from-purple-600 to-blue-600 hover:opacity-90 min-h-[44px] ${isMobile ? 'mb-4' : ''}`}
      >
        Save Preferences
      </Button>
    </div>
  );
};
